import { render, staticRenderFns } from "./table-cell-item.vue?vue&type=template&id=d64bc01e&scoped=true"
import script from "./table-cell-item.vue?vue&type=script&lang=js"
export * from "./table-cell-item.vue?vue&type=script&lang=js"
import style0 from "./table-cell-item.vue?vue&type=style&index=0&id=d64bc01e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64bc01e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d64bc01e')) {
      api.createRecord('d64bc01e', component.options)
    } else {
      api.reload('d64bc01e', component.options)
    }
    module.hot.accept("./table-cell-item.vue?vue&type=template&id=d64bc01e&scoped=true", function () {
      api.rerender('d64bc01e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/pbc-management/table-cell-item.vue"
export default component.exports